import { css } from "styles/styled_components";

const title = css`
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export default title;
